import { TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { CustomDomainTypeSchema } from './custom-domain.schema';

export const ApplicationCustomDomainParamsSchema = Type.Object(
  {
    appId: TypeIdSchema('app'),
    type: CustomDomainTypeSchema,
  },
  { additionalProperties: false },
);

export const OrganizationCustomDomainParamsSchema = Type.Object(
  {
    orgId: TypeIdSchema('organization'),
    type: CustomDomainTypeSchema,
  },
  { additionalProperties: false },
);

export const CustomDomainBodySchema = Type.Object(
  {
    cname: Type.String(),
  },
  { additionalProperties: false },
);

export type ApplicationCustomDomainParams = Static<typeof ApplicationCustomDomainParamsSchema>;
export type OrganizationCustomDomainParams = Static<typeof OrganizationCustomDomainParamsSchema>;
export type CustomDomainBody = Static<typeof CustomDomainBodySchema>;
